module.exports = __webpack_public_path__ + "img/2.459540ee.jpg";